// Mock data for Gemini Tech Labs website

export const services = [
  {
    id: 'erp-implementation',
    title: 'ERP Implementation & Customization',
    icon: 'Database',
    description: 'Comprehensive ERP solutions tailored to your business needs',
    details: 'We specialize in implementing and customizing leading ERP platforms including QuickBooks, Zoho, Odoo, Microsoft Dynamics, and Tally Accounting Software. Our expert consultants ensure seamless integration with your existing business processes.',
    features: ['QuickBooks Implementation', 'Zoho Customization', 'Odoo Development', 'Microsoft Dynamics', 'Tally Integration'],
    image: 'https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg'
  },
  {
    id: 'ai-process-automation',
    title: 'Process Automation using Artificial Intelligence',
    icon: 'Bot',
    description: 'Intelligent automation powered by AI for maximum efficiency',
    details: 'Transform your business processes with AI-powered automation. From AI Business Agents and WhatsApp automation to Voice AI and Document Intelligence, we help you automate repetitive tasks, reduce manual effort, and increase productivity.',
    features: ['AI Business Agents', 'WhatsApp AI Automation', 'Voice AI Agents', 'Document Intelligence', 'Intelligent Workflow Automation'],
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995'
  },
  {
    id: 'integrations',
    title: 'Integration & Automation Services',
    icon: 'Workflow',
    description: 'Seamlessly connect your business systems for maximum efficiency',
    details: 'Our integration services connect disparate systems, automate workflows, and enable real-time data synchronization across your entire technology stack.',
    features: ['Third-party Integrations', 'WhatsApp Business API', 'Custom Plugin Development', 'API Development', 'Data Migration'],
    image: 'https://images.unsplash.com/photo-1644088379091-d574269d422f'
  },
  {
    id: 'digital-transformation',
    title: 'Digital Transformation & Marketing',
    icon: 'TrendingUp',
    description: 'Transform your business for the digital age',
    details: 'Comprehensive digital transformation services including SEO optimization, digital marketing strategies, and brand visibility solutions.',
    features: ['SEO Optimization', 'Digital Marketing', 'Brand Strategy', 'Social Media Management', 'Content Marketing'],
    image: 'https://images.unsplash.com/photo-1644329770639-1a20809b82a3'
  },
  {
    id: 'mobile-development',
    title: 'Mobile App Development',
    icon: 'Smartphone',
    description: 'Custom mobile solutions for iOS and Android',
    details: 'End-to-end mobile application development services to bring your business to your customers fingertips.',
    features: ['iOS Development', 'Android Development', 'Cross-platform Apps', 'App Maintenance', 'UI/UX Design'],
    image: 'https://images.unsplash.com/photo-1531297484001-80022131f5a1'
  },
  {
    id: 'tech-distribution',
    title: 'Technology Distribution',
    icon: 'Package',
    description: 'Authorized resellers of leading technology solutions',
    details: 'We are authorized resellers and implementation partners for multiple ERP and automation platforms, providing pre-built, industry-ready solutions.',
    features: ['Software Licensing', 'Implementation Support', 'Training Programs', 'Technical Support', 'Custom Solutions'],
    image: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b'
  }
];

export const industries = [
  {
    id: 'manufacturing',
    name: 'Manufacturing',
    icon: 'Factory',
    description: 'Streamline production, inventory, and supply chain operations',
    image: 'https://images.pexels.com/photos/159298/gears-cogs-machine-machinery-159298.jpeg'
  },
  {
    id: 'construction',
    name: 'Construction',
    icon: 'HardHat',
    description: 'Project management and resource optimization solutions',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab'
  },
  {
    id: 'retail',
    name: 'Retail',
    icon: 'ShoppingCart',
    description: 'POS systems, inventory management, and e-commerce integration',
    image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095'
  },
  {
    id: 'hospitality',
    name: 'Hospitality',
    icon: 'Hotel',
    description: 'Hotel management systems and customer experience solutions',
    image: 'https://images.unsplash.com/photo-1606857521015-7f9fcf423740'
  },
  {
    id: 'healthcare',
    name: 'Healthcare',
    icon: 'Heart',
    description: 'Patient management and healthcare automation systems',
    image: 'https://images.unsplash.com/photo-1573164713712-03790a178651'
  },
  {
    id: 'education',
    name: 'Education',
    icon: 'GraduationCap',
    description: 'Learning management and administrative automation',
    image: 'https://images.unsplash.com/photo-1523961131990-5ea7c61b2107'
  }
];

export const partners = [
  { name: 'QuickBooks', logo: '/partners/quickbooks.png' },
  { name: 'Zoho', logo: '/partners/zoho.png' },
  { name: 'Odoo', logo: '/partners/odoo.png' },
  { name: 'Microsoft Dynamics', logo: '/partners/microsoft.png' },
  { name: 'Tally', logo: '/partners/tally.png' }
];

export const testimonials = [
  {
    id: 1,
    name: 'John Anderson',
    position: 'CEO, TechCorp Industries',
    content: 'Gemini Tech Labs transformed our entire business operations. Their ERP implementation was seamless and the team was incredibly professional.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095'
  },
  {
    id: 2,
    name: 'Sarah Mitchell',
    position: 'Operations Director, Global Retail Co.',
    content: 'The integration services provided by Gemini Tech Labs helped us connect all our systems. We\'ve seen a 40% increase in operational efficiency.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1573164713712-03790a178651'
  },
  {
    id: 3,
    name: 'Ahmed Al-Rashid',
    position: 'CTO, Emirates Construction',
    content: 'Outstanding service and expertise. Their team delivered beyond our expectations and continues to provide excellent support.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1606857521015-7f9fcf423740'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: '5 Reasons Why Your Business Needs ERP in 2025',
    slug: '5-reasons-why-your-business-needs-erp-2025',
    excerpt: 'Discover how ERP systems can transform your business operations and drive growth in the modern digital landscape.',
    content: 'Full article content here...',
    category: 'ERP',
    author: 'Rajesh Bahl',
    date: '2025-01-15',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1644325349124-d1756b79dd42'
  },
  {
    id: 2,
    title: 'Digital Transformation: A Complete Guide for SMEs',
    slug: 'digital-transformation-guide-smes',
    excerpt: 'A comprehensive guide to help small and medium enterprises navigate their digital transformation journey.',
    content: 'Full article content here...',
    category: 'Digital Transformation',
    author: 'Rajesh Bahl',
    date: '2025-01-10',
    readTime: '8 min read',
    image: 'https://images.unsplash.com/photo-1644329770639-1a20809b82a3'
  },
  {
    id: 3,
    title: 'WhatsApp Business Integration: Boost Customer Engagement',
    slug: 'whatsapp-business-integration-guide',
    excerpt: 'Learn how WhatsApp Business API can revolutionize your customer communication and support.',
    content: 'Full article content here...',
    category: 'Integration',
    author: 'Vikram Patel',
    date: '2025-01-05',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1661862649743-2799867c32b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx3aGF0c2FwcCUyMGxvZ298ZW58MHx8fHwxNzYwNTE0NjcwfDA&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    title: 'Choosing the Right ERP: QuickBooks vs Zoho vs Odoo',
    slug: 'choosing-right-erp-comparison',
    excerpt: 'An in-depth comparison of popular ERP platforms to help you make the right choice for your business.',
    content: 'Full article content here...',
    category: 'ERP',
    author: 'Rajesh Bahl',
    date: '2024-12-28',
    readTime: '10 min read',
    image: 'https://images.unsplash.com/photo-1717386255773-1e3037c81788'
  },
  {
    id: 5,
    title: 'Finance Transformation Through ERP: From Transactional Control to Strategic Value',
    slug: 'finance-transformation-through-erp',
    excerpt: 'ERP-led finance transformation enables organizations to move beyond manual processes and fragmented data toward real-time insight, control, and strategic decision-making.',
    content: 'Finance transformation has become a strategic priority for organizations seeking agility, transparency, and sustainable growth. At the center of this transformation lies Enterprise Resource Planning (ERP) systems, which act as the digital backbone of modern finance functions. Rather than being limited to accounting automation, ERP-driven finance transformation reshapes processes, roles, and decision-making across the enterprise.\n\nTraditionally, finance teams spent a significant portion of their time on transactional activities such as data entry, reconciliations, and month-end close. Legacy systems and spreadsheets created silos, increased error risk, and delayed reporting. Modern ERP platforms address these challenges by standardizing core finance processes—record to report, procure to pay, and order to cash—on a single, integrated platform. This standardization improves data integrity and enables faster, more reliable financial close cycles.\n\nA key benefit of ERP-led finance transformation is real-time visibility. With unified data models and embedded analytics, finance leaders gain immediate access to performance metrics, cash positions, and compliance indicators. This shift allows finance to move from a backward-looking reporting role to a forward-looking advisory function, supporting business leaders with scenario modeling, forecasting, and decision insights.\n\nERP systems also play a critical role in enabling automation and controls. Features such as workflow-driven approvals, automated journal entries, and built-in compliance checks reduce manual effort while strengthening governance. When combined with technologies like RPA and AI, ERP platforms can further automate repetitive tasks and highlight anomalies, freeing finance professionals to focus on value-added analysis.\n\nHowever, successful finance transformation is not achieved through technology alone. ERP implementations must be accompanied by process redesign, change management, and skills development. Organizations that treat ERP as a business transformation—rather than an IT project—are more likely to realize benefits such as cost reduction, faster close, improved compliance, and enhanced business partnering.\n\nIn an increasingly volatile and data-driven business environment, ERP-enabled finance transformation provides the foundation for resilience and growth. By integrating data, automating processes, and empowering finance teams with insight, ERP systems help finance evolve into a strategic engine that drives enterprise-wide value.',
    category: 'Digital Transformation',
    author: 'Rajesh Bahl',
    date: '2025-01-20',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c'
  }



];

export const solutions = [
  {
    id: 1,
    title: 'Inventory Management Plus',
    description: 'Advanced inventory tracking and management solution for retail and manufacturing',
    category: 'Ready-made',
    price: 'Contact for pricing',
    features: ['Real-time tracking', 'Multi-location support', 'Automated reordering', 'Analytics dashboard']
  },
  {
    id: 2,
    title: 'Custom WhatsApp Plugin',
    description: 'Integrate WhatsApp Business API with your existing CRM or ERP system',
    category: 'Custom',
    price: 'Custom pricing',
    features: ['Automated messaging', 'Template management', 'Customer segmentation', 'Analytics']
  },
  {
    id: 3,
    title: 'Payment Gateway Integration',
    description: 'Seamless payment processing integration for your business applications',
    category: 'Ready-made',
    price: 'Contact for pricing',
    features: ['Multiple payment methods', 'Secure transactions', 'Automated reconciliation', 'Real-time reporting']
  }
];